import { useContext, useEffect } from 'react'
import { FieldValues, UseFormSetValue } from 'react-hook-form'
import { LanguagesRes } from 'shared/types/general.types'
import { StoreSettingsContext } from 'store'

type UseSetDefaultLanguageProps = {
	languages: LanguagesRes | undefined
	setValue: UseFormSetValue<FieldValues>
}

export const useSetDefaultLanguage = ({ languages, setValue }: UseSetDefaultLanguageProps) => {
	const storeCtx = useContext(StoreSettingsContext)

	useEffect(() => {
		if (languages && storeCtx?.storeSettings?.default_language) {
			setValue('default_language', {
				value: storeCtx?.storeSettings?.default_language,
				label: languages?.find(
					(language) => language.value === storeCtx?.storeSettings?.default_language
				)?.display_name
			})
		}
	}, [languages, storeCtx?.storeSettings?.default_language])
}
